import { memo, useRef } from 'react';
// import { MusicForYouHeader } from "@components/Header/MusicForYouHeader";
import MusicPageContent from './components/MusicPageContent';

export const MusicPage = memo(() => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  return (
    <div className="flex flex-col h-full">
      <MusicPageContent scrollContainerRef={scrollContainerRef} />
    </div>
  );
});

MusicPage.displayName = 'MusicPage';
